// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.lease.LeasingCheckPaymentsWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeasingCheckPaymentsWebApiHandler_checkActivePayments,
  LeasingCheckPaymentsWebApiHandler_checkActivePayments_Path,
} from '@zg-rentals/ts-leasing-client';

import type { LeasingCheckActivePaymentsResponseDto } from '@zg-rentals/ts-leasing-client';

interface CheckActivePaymentsParams {
  leaseId: number;
}

export type LeasingCheckPaymentsWebApiHandler_checkActivePayments_Options = UseQueryOptions<
  LeasingCheckActivePaymentsResponseDto,
  unknown,
  LeasingCheckActivePaymentsResponseDto,
  readonly [string, CheckActivePaymentsParams]
>;

const LeasingCheckPaymentsWebApiHandler_checkActivePayments_GetKey = (getParams: CheckActivePaymentsParams) =>
  [LeasingCheckPaymentsWebApiHandler_checkActivePayments_Path, getParams] as const;

export const LeasingCheckPaymentsWebApiHandler_checkActivePayments_queryOptions = (
  getParams: CheckActivePaymentsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeasingCheckPaymentsWebApiHandler_checkActivePayments_GetKey(getParams),
    queryFn: () => LeasingCheckPaymentsWebApiHandler_checkActivePayments(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * check if payments are active for a lease
 */
export const useLeasingCheckPaymentsWebApiHandler_checkActivePayments = (
  getParams: CheckActivePaymentsParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingCheckPaymentsWebApiHandler_checkActivePayments_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...LeasingCheckPaymentsWebApiHandler_checkActivePayments_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeasingCheckPaymentsWebApiHandler_checkActivePayments.getKey =
  LeasingCheckPaymentsWebApiHandler_checkActivePayments_GetKey;
